import { Component } from '@angular/core';

@Component({
  templateUrl: './control-demo.component.html',
  styleUrls: ['./control-demo.component.scss'],
})
export class ControlDemoComponent {
}



// WEBPACK FOOTER //
// ./src/app/form/control/control-demo.component.ts